import {
  MODULE_TYPE,
  transformModuleAssets
} from "seneca-common/features/module/module-types/image-label";
import { ModuleRegistry } from "seneca-common/features/module/registry";

import { DEVICE_REQUIREMENTS } from "./const";

export const registerComponentStaticInformation = (
  moduleRegistry: ModuleRegistry
) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.componentStaticInformation()
    .deviceRequirements(DEVICE_REQUIREMENTS) // Pass an empty object here to allow the transformation to work. This is becasue the image size is
    // defined by the content source (rather than the module component) as the content creators define
    // the image height/width that looks good.
    // p.s. if we create any new modules that also require an empty object to be passed like this it might
    //      be nice to add this capability to the builders. Not adding now as it's currently an edge case.
    .assetParameters({})
    .transformModuleAssets(transformModuleAssets)
    .root.register();
